import React from 'react';
import { Desktop, Mobile } from '../../../../app-responsive';
import './review-table.css';

const ReviewTable = (props) => {
  const {
    authorableContent,
    emailList,
    emailSelectionCheckedStatus,
  } = props;

  const {
    emailHeading,
    actionHeading,
  } = authorableContent;

  const emailListContentDesktop = emailList.map(email => (
    <div className="row email-row-item" key={email}>
      <div className="col-6">
        <div className="email-text">{email}</div>
      </div>
      <div className="col-6">
        <div className="action-text">{emailSelectionCheckedStatus[email]}</div>
      </div>
    </div>
  ));
  const emailListContentMobile = emailList.map(email => (
    <div className="row email-row-item" key={email}>

      <div className="col-12 mobile-heading">
        {emailHeading}
      </div>
      <div className="col-12 mobile-text">
        {email}
      </div>
      <div className="col-3 mobile-sub-heading">
        {actionHeading}
      </div>
      <div className="col-9 mobile-sub-text text-left">
        {emailSelectionCheckedStatus[email]}
      </div>
    </div>
  ));


  return (
    <div className="review-table-section">
      <Desktop>
        <div className="row">
          <div className="col-6 heading">
            {emailHeading}
          </div>
          <div className="col-6 heading">
            {actionHeading}
          </div>
        </div>
        {emailListContentDesktop}
      </Desktop>
      <Mobile>
        {emailListContentMobile}
      </Mobile>
    </div>
  );
};

export default ReviewTable;

